import App from './App.vue';

export default {
  path: '/CDS_VF_ChatDetail',
  name: 'CDS_VF_ChatDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'チャット履歴',
      controller: 'CDS_CTR_ChatDetail',
    },
  },
};
